// import React, { useState } from 'react';
// import '../../Styles/GSTAdmin.css';

// const GSTAdminPanel = () => {
//   const [activeTab, setActiveTab] = useState('gstr1');
//   const [selectedPeriod, setSelectedPeriod] = useState('Mar 2026');

//   // Updated: Bus ticket data instead of invoices (for GSTR-1)
//   const busTickets = [
//     { id: 1, operatorGSTIN: '27AAACA1234A1Z', ticketNo: 'ROAM-2026-001', date: '15 Mar 2026', route: 'Bangalore → Chennai', taxableValue: 1200, igst: 60, serviceType: 'AC Bus', tripType: 'Inter-state' },
//     { id: 2, operatorGSTIN: '27AAACB5678B2Z', ticketNo: 'ROAM-2026-002', date: '16 Mar 2026', route: 'Mumbai → Pune', taxableValue: 800, cgst: 20, sgst: 20, serviceType: 'AC Bus', tripType: 'Intra-state' },
//     { id: 3, operatorGSTIN: '27AAACC9012C3Z', ticketNo: 'ROAM-2026-003', date: '17 Mar 2026', route: 'Delhi → Jaipur', taxableValue: 950, igst: 47.5, serviceType: 'Luxury Bus', tripType: 'Inter-state' },
//     { id: 4, operatorGSTIN: 'EXEMPT-001', ticketNo: 'ROAM-2026-004', date: '18 Mar 2026', route: 'Pune → Nashik', taxableValue: 500, taxAmount: 0, serviceType: 'Non-AC Bus', tripType: 'Intra-state', isExempt: true },
//     { id: 5, operatorGSTIN: '27AAACD3456D4Z', ticketNo: 'ROAM-2026-005', date: '19 Mar 2026', route: 'Hyderabad → Bangalore', taxableValue: 1500, igst: 75, serviceType: 'AC Sleeper', tripType: 'Inter-state' },
//   ];

//   // Updated: GSTR-3B data for bus operations
//   const liabilitySummary = {
//     igst: { liability: 18500, itcUsed: 15000, cashPaid: 3500 },      // Inter-state bus tickets
//     cgst: { liability: 8750, itcUsed: 7000, cashPaid: 1750 },       // Intra-state (central share)
//     sgst: { liability: 8750, itcUsed: 7000, cashPaid: 1750 },       // Intra-state (state share)
//     cess: { liability: 0, itcUsed: 0, cashPaid: 0 }                 // No cess on passenger transport
//   };

//   // Updated: Ledgers reflecting bus business expenses
//   const ledgers = {
//     cash: 12500,           // Cash available for tax payment
//     credit: 85000          // ITC from fuel, maintenance, vehicle purchases
//   };

//   // Updated: Summary cards for bus platform
//   const summaryCards = [
//     { title: 'Total Tickets Sold', value: '1,245', change: '+15%', icon: '🎫', color: 'blue' },
//     { title: 'Total GST Collected', value: '₹1,24,500', change: '+12%', icon: '💰', color: 'green' },
//     { title: 'ITC Available (Fuel + Maintenance)', value: '₹85,000', change: '+8%', icon: '⛽', color: 'purple' },
//     { title: 'Net GST Payable', value: '₹39,500', change: '-5%', icon: '🚌', color: 'orange' },
//   ];

//   const getStatusBadgeClass = (status) => {
//     const classes = {
//       filed: 'status-badge-filed',
//       pending: 'status-badge-pending',
//       draft: 'status-badge-draft',
//       error: 'status-badge-error'
//     };
//     return classes[status] || classes.draft;
//   };

//   // Calculate totals from bus tickets
//   const totalTaxableValue = busTickets.reduce((sum, ticket) => sum + ticket.taxableValue, 0);
//   const totalTaxAmount = busTickets.reduce((sum, ticket) => {
//     return sum + (ticket.igst || 0) + (ticket.cgst || 0) + (ticket.sgst || 0);
//   }, 0);

//   return (
//     <div className="gst-admin-container">
//       {/* Header - Updated for Roam */}
//       <header className="gst-header">
//         <div className="header-content">
//           <div className="logo-section">
//             <div className="logo-icon">
//               <span>🚌</span>
//             </div>
//             <div>
//               <h1 className="header-title">Roam - GST Compliance Hub</h1>
//               <p className="header-subtitle">Manage bus transport GSTR-1 & GSTR-3B returns</p>
//             </div>
//           </div>
//           <div className="header-actions">
//             <div className="period-selector">
//               <span className="calendar-icon">📅</span>
//               <select 
//                 className="period-dropdown"
//                 value={selectedPeriod}
//                 onChange={(e) => setSelectedPeriod(e.target.value)}
//               >
//                 <option>Mar 2026</option>
//                 <option>Feb 2026</option>
//                 <option>Jan 2026</option>
//               </select>
//             </div>
//             <button className="btn-primary">
//               + New Filing
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="main-content">
//         {/* Summary Cards - Updated for bus business */}
//         <div className="summary-grid">
//           {summaryCards.map((card, idx) => (
//             <div key={idx} className={`summary-card summary-card-${card.color}`}>
//               <div className="card-header">
//                 <div>
//                   <p className="card-title">{card.title}</p>
//                   <h3 className="card-value">{card.value}</h3>
//                   <p className={`card-change ${card.change.startsWith('+') ? 'change-positive' : 'change-negative'}`}>
//                     {card.change} from last month
//                   </p>
//                 </div>
//                 <div className={`card-icon card-icon-${card.color}`}>
//                   <span>{card.icon}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Tabs Section */}
//         <div className="tabs-container">
//           <div className="tabs-header">
//             <button
//               onClick={() => setActiveTab('gstr1')}
//               className={`tab-button ${activeTab === 'gstr1' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">🎫</span>
//               <span>GSTR-1 (Ticket Sales Details)</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('gstr3b')}
//               className={`tab-button ${activeTab === 'gstr3b' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">📊</span>
//               <span>GSTR-3B (Tax Summary)</span>
//             </button>
//           </div>

//           <div className="tab-content">
//             {/* GSTR-1 Content - Updated for bus tickets */}
//             {activeTab === 'gstr1' && (
//               <div className="gstr1-content">
//                 {/* Action Bar */}
//                 <div className="action-bar">
//                   <div className="action-buttons">
//                     <button className="btn-secondary">
//                       <span>➕</span>
//                       <span>Add Ticket</span>
//                     </button>
//                     <button className="btn-outline">
//                       <span>📤</span>
//                       <span>Bulk Upload Tickets</span>
//                     </button>
//                     <button className="btn-outline">
//                       <span>📥</span>
//                       <span>Download Ticket Template</span>
//                     </button>
//                   </div>
//                   <div className="search-section">
//                     <div className="search-box">
//                       <span className="search-icon">🔍</span>
//                       <input
//                         type="text"
//                         placeholder="Search by ticket no., route, or operator..."
//                         className="search-input"
//                       />
//                     </div>
//                     <button className="filter-btn">
//                       <span>⚙️</span>
//                     </button>
//                   </div>
//                 </div>

//                 {/* Ticket Table - Updated columns for bus transport */}
//                 <div className="table-container">
//                   <table className="data-table">
//                     <thead>
//                       <tr>
//                         <th>Ticket No.</th>
//                         <th>Operator GSTIN</th>
//                         <th>Date</th>
//                         <th>Route</th>
//                         <th>Service Type</th>
//                         <th>Trip Type</th>
//                         <th className="text-right">Ticket Value</th>
//                         <th className="text-right">GST</th>
//                         <th className="text-center">Status</th>
//                         <th className="text-center">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {busTickets.map((ticket) => (
//                         <tr key={ticket.id}>
//                           <td>{ticket.ticketNo}</td>
//                           <td>{ticket.operatorGSTIN}</td>
//                           <td>{ticket.date}</td>
//                           <td>{ticket.route}</td>
//                           <td>
//                             <span className={`type-badge ${ticket.serviceType === 'Non-AC Bus' ? 'type-exempt' : 'type-b2b'}`}>
//                               {ticket.serviceType}
//                             </span>
//                           </td>
//                           <td>
//                             <span className={`trip-badge ${ticket.tripType === 'Inter-state' ? 'trip-inter' : 'trip-intra'}`}>
//                               {ticket.tripType}
//                             </span>
//                           </td>
//                           <td className="text-right">₹{ticket.taxableValue.toLocaleString()}</td>
//                           <td className="text-right">
//                             {ticket.isExempt ? (
//                               <span className="exempt-text">Exempt (0%)</span>
//                             ) : (
//                               `₹{(ticket.igst || ticket.cgst + ticket.sgst || 0).toLocaleString()}`
//                             )}
//                           </td>
//                           <td className="text-center">
//                             <div className="status-indicator">
//                               <span className="status-dot status-dot-green"></span>
//                               <span className="status-text">Validated</span>
//                             </div>
//                           </td>
//                           <td className="text-center">
//                             <button className="action-menu">⋮</button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* Summary Footer - Updated */}
//                 <div className="summary-footer">
//                   <div className="summary-stats">
//                     <div>
//                       <p className="stat-label">Total Ticket Sales (Excluding GST)</p>
//                       <p className="stat-value">₹{totalTaxableValue.toLocaleString()}</p>
//                     </div>
//                     <div>
//                       <p className="stat-label">Total GST Collected</p>
//                       <p className="stat-value">₹{totalTaxAmount.toLocaleString()}</p>
//                     </div>
//                     <div>
//                       <p className="stat-label">Exempt Sales (Non-AC Buses)</p>
//                       <p className="stat-value">₹500</p>
//                     </div>
//                   </div>
//                   <button className="btn-generate">
//                     <span>Generate GSTR-1 Summary</span>
//                     <span>→</span>
//                   </button>
//                 </div>

//                 {/* GST Rate Info Box */}
//                 <div className="gst-info-box">
//                   <span className="info-icon">ℹ️</span>
//                   <div className="info-content">
//                     <strong>GST Rates Applied:</strong> AC Buses @ 5% IGST/CGST+SGST | Non-AC Buses @ 0% (Exempt) | Luxury Coaches @ 5% or 12% (Option)
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* GSTR-3B Content - Updated for bus operations */}
//             {activeTab === 'gstr3b' && (
//               <div className="gstr3b-content">
//                 {/* Ledger Cards - Updated */}
//                 <div className="ledger-grid">
//                   <div className="ledger-card ledger-card-green">
//                     <div className="ledger-header">
//                       <div className="ledger-icon">
//                         <span>💰</span>
//                       </div>
//                       <div className="ledger-info">
//                         <p className="ledger-label">Electronic Cash Ledger</p>
//                         <p className="ledger-amount">₹{ledgers.cash.toLocaleString()}</p>
//                       </div>
//                       <span className="ledger-trend">↗</span>
//                     </div>
//                     <div className="ledger-footer">Available for tax payment from ticket collections</div>
//                   </div>
                  
//                   <div className="ledger-card ledger-card-purple">
//                     <div className="ledger-header">
//                       <div className="ledger-icon">
//                         <span>⛽</span>
//                       </div>
//                       <div className="ledger-info">
//                         <p className="ledger-label">Electronic Credit Ledger (ITC)</p>
//                         <p className="ledger-amount">₹{ledgers.credit.toLocaleString()}</p>
//                       </div>
//                       <span className="ledger-trend">↗</span>
//                     </div>
//                     <div className="ledger-footer">ITC from fuel, maintenance, vehicle purchases (eligible buses)</div>
//                   </div>
//                 </div>

//                 {/* Liability Table - Updated for bus transport */}
//                 <div className="liability-table-container">
//                   <div className="table-header">
//                     <h3 className="section-title">Tax Liability & ITC Utilization (Bus Operations)</h3>
//                     <p className="table-subtitle">Based on ticket sales for {selectedPeriod}</p>
//                   </div>
//                   <div className="table-responsive">
//                     <table className="liability-table">
//                       <thead>
//                         <tr>
//                           <th>Tax Head</th>
//                           <th className="text-right">Total Liability (from tickets)</th>
//                           <th className="text-right">ITC Used (fuel/maintenance)</th>
//                           <th className="text-right">Cash to Pay</th>
//                           <th className="text-center">Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td className="font-medium uppercase">IGST</td>
//                           <td className="text-right font-semibold">₹{liabilitySummary.igst.liability.toLocaleString()}</td>
//                           <td className="text-right text-green">- ₹{liabilitySummary.igst.itcUsed.toLocaleString()}</td>
//                           <td className="text-right font-bold">₹{liabilitySummary.igst.cashPaid.toLocaleString()}</td>
//                           <td className="text-center">
//                             <span className="status-badge status-badge-success">✓ Settled</span>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td className="font-medium uppercase">CGST</td>
//                           <td className="text-right font-semibold">₹{liabilitySummary.cgst.liability.toLocaleString()}</td>
//                           <td className="text-right text-green">- ₹{liabilitySummary.cgst.itcUsed.toLocaleString()}</td>
//                           <td className="text-right font-bold">₹{liabilitySummary.cgst.cashPaid.toLocaleString()}</td>
//                           <td className="text-center">
//                             <span className="status-badge status-badge-success">✓ Settled</span>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td className="font-medium uppercase">SGST</td>
//                           <td className="text-right font-semibold">₹{liabilitySummary.sgst.liability.toLocaleString()}</td>
//                           <td className="text-right text-green">- ₹{liabilitySummary.sgst.itcUsed.toLocaleString()}</td>
//                           <td className="text-right font-bold">₹{liabilitySummary.sgst.cashPaid.toLocaleString()}</td>
//                           <td className="text-center">
//                             <span className="status-badge status-badge-success">✓ Settled</span>
//                           </td>
//                         </tr>
//                       </tbody>
//                       <tfoot>
//                         <tr>
//                           <td className="font-bold">Total</td>
//                           <td className="text-right font-bold">₹{Object.values(liabilitySummary).reduce((sum, h) => sum + h.liability, 0).toLocaleString()}</td>
//                           <td className="text-right font-bold text-green">- ₹{Object.values(liabilitySummary).reduce((sum, h) => sum + h.itcUsed, 0).toLocaleString()}</td>
//                           <td className="text-right font-bold text-blue">₹{Object.values(liabilitySummary).reduce((sum, h) => sum + h.cashPaid, 0).toLocaleString()}</td>
//                           <td></td>
//                         </tr>
//                       </tfoot>
//                     </table>
//                   </div>
//                 </div>

//                 {/* ITC Eligibility Note */}
//                 <div className="itc-note">
//                   <span className="note-icon">ⓘ</span>
//                   <div className="note-content">
//                     <strong>ITC Eligibility Note:</strong> You can claim ITC on fuel, repairs, and vehicle purchases for buses with seating capacity &gt; 13 persons (including driver). ITC not available for minibuses/vehicles with ≤13 seats.
//                   </div>
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="action-buttons-footer">
//                   <button className="btn-outline-secondary">
//                     Save as Draft
//                   </button>
//                   <button className="btn-primary-gradient">
//                     Preview & File GSTR-3B
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Recent Activity - Updated */}
//         <div className="recent-activity">
//           <div className="activity-header">
//             <h3 className="section-title">Recent GST Filing Activity</h3>
//             <button className="view-all-btn">View all →</button>
//           </div>
//           <div className="activity-list">
//             {[
//               { type: 'GSTR-3B', period: 'Feb 2026', date: '20 Mar 2026', status: 'filed', arn: 'ARN123456789', taxPaid: '₹39,500' },
//               { type: 'GSTR-1', period: 'Feb 2026', date: '18 Mar 2026', status: 'filed', arn: 'ARN987654321', tickets: '1,128' },
//               { type: 'GSTR-3B', period: 'Jan 2026', date: '19 Feb 2026', status: 'filed', arn: 'ARN456789123', taxPaid: '₹42,000' },
//             ].map((activity, idx) => (
//               <div key={idx} className="activity-item">
//                 <div className="activity-left">
//                   <div className={`activity-icon ${activity.type === 'GSTR-1' ? 'icon-blue' : 'icon-green'}`}>
//                     {activity.type === 'GSTR-1' ? '🎫' : '📊'}
//                   </div>
//                   <div>
//                     <p className="activity-title">{activity.type}</p>
//                     <p className="activity-subtitle">{activity.period} • ARN: {activity.arn}</p>
//                     {activity.taxPaid && <p className="activity-subtitle">Tax Paid: {activity.taxPaid}</p>}
//                     {activity.tickets && <p className="activity-subtitle">Tickets: {activity.tickets}</p>}
//                   </div>
//                 </div>
//                 <div className="activity-right">
//                   <span className={`status-badge ${getStatusBadgeClass(activity.status)}`}>
//                     {activity.status.charAt(0).toUpperCase() + activity.status.slice(1)}
//                   </span>
//                   <span className="activity-date">{activity.date}</span>
//                   <button className="download-btn">📥</button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GSTAdminPanel;

// import React, { useState, useEffect } from 'react';
// import '../../Styles/GSTAdmin.css';

// // Skeleton Components
// const SkeletonSummaryCard = () => (
//   <div className="summary-card skeleton">
//     <div className="card-header">
//       <div>
//         <div className="skeleton-title"></div>
//         <div className="skeleton-value"></div>
//         <div className="skeleton-change"></div>
//       </div>
//       <div className="skeleton-icon"></div>
//     </div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-status"></div></td>
//     <td><div className="skeleton-action"></div></td>
//    </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>Ticket No.</th>
//           <th>Operator GSTIN</th>
//           <th>Date</th>
//           <th>Route</th>
//           <th>Service Type</th>
//           <th>Trip Type</th>
//           <th className="text-right">Ticket Value</th>
//           <th className="text-right">GST</th>
//           <th className="text-center">Status</th>
//           <th className="text-center">Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonLedgerCard = () => (
//   <div className="ledger-card skeleton">
//     <div className="ledger-header">
//       <div className="skeleton-ledger-icon"></div>
//       <div className="ledger-info">
//         <div className="skeleton-ledger-label"></div>
//         <div className="skeleton-ledger-amount"></div>
//       </div>
//       <div className="skeleton-trend"></div>
//     </div>
//     <div className="skeleton-ledger-footer"></div>
//   </div>
// );

// const SkeletonLiabilityRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//   </tr>
// );

// const SkeletonActivityItem = () => (
//   <div className="activity-item skeleton">
//     <div className="activity-left">
//       <div className="skeleton-activity-icon"></div>
//       <div>
//         <div className="skeleton-activity-title"></div>
//         <div className="skeleton-activity-subtitle"></div>
//       </div>
//     </div>
//     <div className="activity-right">
//       <div className="skeleton-badge"></div>
//       <div className="skeleton-date"></div>
//       <div className="skeleton-download"></div>
//     </div>
//   </div>
// );

// const GSTAdminPanel = () => {
//   const [activeTab, setActiveTab] = useState('gstr1');
//   const [selectedPeriod, setSelectedPeriod] = useState('Mar 2026');
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
  
//   // Simulate loading data
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 1500);
    
//     return () => clearTimeout(timer);
//   }, []);

//   // Updated: Bus ticket data instead of invoices (for GSTR-1)
//   const busTickets = [
//     { id: 1, operatorGSTIN: '27AAACA1234A1Z', ticketNo: 'ROAM-2026-001', date: '15 Mar 2026', route: 'Bangalore → Chennai', taxableValue: 1200, igst: 60, serviceType: 'AC Bus', tripType: 'Inter-state' },
//     { id: 2, operatorGSTIN: '27AAACB5678B2Z', ticketNo: 'ROAM-2026-002', date: '16 Mar 2026', route: 'Mumbai → Pune', taxableValue: 800, cgst: 20, sgst: 20, serviceType: 'AC Bus', tripType: 'Intra-state' },
//     { id: 3, operatorGSTIN: '27AAACC9012C3Z', ticketNo: 'ROAM-2026-003', date: '17 Mar 2026', route: 'Delhi → Jaipur', taxableValue: 950, igst: 47.5, serviceType: 'Luxury Bus', tripType: 'Inter-state' },
//     { id: 4, operatorGSTIN: 'EXEMPT-001', ticketNo: 'ROAM-2026-004', date: '18 Mar 2026', route: 'Pune → Nashik', taxableValue: 500, taxAmount: 0, serviceType: 'Non-AC Bus', tripType: 'Intra-state', isExempt: true },
//     { id: 5, operatorGSTIN: '27AAACD3456D4Z', ticketNo: 'ROAM-2026-005', date: '19 Mar 2026', route: 'Hyderabad → Bangalore', taxableValue: 1500, igst: 75, serviceType: 'AC Sleeper', tripType: 'Inter-state' },
//   ];

//   // Filtered tickets based on search
//   const filteredTickets = busTickets.filter(ticket => 
//     ticket.ticketNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     ticket.route.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     ticket.operatorGSTIN.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Updated: GSTR-3B data for bus operations
//   const liabilitySummary = {
//     igst: { liability: 18500, itcUsed: 15000, cashPaid: 3500 },
//     cgst: { liability: 8750, itcUsed: 7000, cashPaid: 1750 },
//     sgst: { liability: 8750, itcUsed: 7000, cashPaid: 1750 },
//     cess: { liability: 0, itcUsed: 0, cashPaid: 0 }
//   };

//   // Updated: Ledgers reflecting bus business expenses
//   const ledgers = {
//     cash: 12500,
//     credit: 85000
//   };

//   // Updated: Summary cards for bus platform
//   const summaryCards = [
//     { title: 'Total Tickets Sold', value: '1,245', change: '+15%', icon: '🎫', color: 'blue' },
//     { title: 'Total GST Collected', value: '₹1,24,500', change: '+12%', icon: '💰', color: 'green' },
//     { title: 'ITC Available (Fuel + Maintenance)', value: '₹85,000', change: '+8%', icon: '⛽', color: 'purple' },
//     { title: 'Net GST Payable', value: '₹39,500', change: '-5%', icon: '🚌', color: 'orange' },
//   ];

//   const getStatusBadgeClass = (status) => {
//     const classes = {
//       filed: 'status-badge-filed',
//       pending: 'status-badge-pending',
//       draft: 'status-badge-draft',
//       error: 'status-badge-error'
//     };
//     return classes[status] || classes.draft;
//   };

//   // Calculate totals from bus tickets
//   const totalTaxableValue = busTickets.reduce((sum, ticket) => sum + ticket.taxableValue, 0);
//   const totalTaxAmount = busTickets.reduce((sum, ticket) => {
//     return sum + (ticket.igst || 0) + (ticket.cgst || 0) + (ticket.sgst || 0);
//   }, 0);

//   // Loading state with skeletons
//   if (loading) {
//     return (
//       <div className="gst-admin-container">
//         {/* Header Skeleton */}
//         <header className="gst-header">
//           <div className="header-content">
//             <div className="logo-section">
//               <div className="skeleton-logo"></div>
//               <div>
//                 <div className="skeleton-header-title"></div>
//                 <div className="skeleton-header-subtitle"></div>
//               </div>
//             </div>
//             <div className="header-actions">
//               <div className="skeleton-period"></div>
//               <div className="skeleton-button"></div>
//             </div>
//           </div>
//         </header>

//         <div className="main-content">
//           {/* Summary Cards Skeleton */}
//           <div className="summary-grid">
//             {[1, 2, 3, 4].map((i) => (
//               <SkeletonSummaryCard key={i} />
//             ))}
//           </div>

//           {/* Tabs Skeleton */}
//           <div className="tabs-container">
//             <div className="tabs-header">
//               <div className="skeleton-tab"></div>
//               <div className="skeleton-tab"></div>
//             </div>
//             <div className="tab-content">
//               {activeTab === 'gstr1' ? (
//                 <>
//                   <div className="action-bar">
//                     <div className="action-buttons">
//                       <div className="skeleton-button-small"></div>
//                       <div className="skeleton-button-small"></div>
//                       <div className="skeleton-button-small"></div>
//                     </div>
//                     <div className="search-section">
//                       <div className="skeleton-search"></div>
//                       <div className="skeleton-filter"></div>
//                     </div>
//                   </div>
//                   <SkeletonTable />
//                   <div className="summary-footer">
//                     <div className="summary-stats">
//                       <div className="skeleton-stat"></div>
//                       <div className="skeleton-stat"></div>
//                       <div className="skeleton-stat"></div>
//                     </div>
//                     <div className="skeleton-generate"></div>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div className="ledger-grid">
//                     <SkeletonLedgerCard />
//                     <SkeletonLedgerCard />
//                   </div>
//                   <div className="liability-table-container">
//                     <div className="skeleton-section-title"></div>
//                     <div className="table-responsive">
//                       <table className="liability-table">
//                         <thead>
//                           <tr>
//                             <th>Tax Head</th>
//                             <th className="text-right">Total Liability</th>
//                             <th className="text-right">ITC Used</th>
//                             <th className="text-right">Cash to Pay</th>
//                             <th className="text-center">Status</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {[1, 2, 3].map((i) => (
//                             <SkeletonLiabilityRow key={i} />
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Recent Activity Skeleton */}
//           <div className="recent-activity">
//             <div className="activity-header">
//               <div className="skeleton-section-title"></div>
//               <div className="skeleton-view-all"></div>
//             </div>
//             <div className="activity-list">
//               {[1, 2, 3].map((i) => (
//                 <SkeletonActivityItem key={i} />
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="gst-admin-container">
//       {/* Header - Updated for Roam */}
//       <header className="gst-header">
//         <div className="header-content">
//           <div className="logo-section">
//             <div className="logo-icon">
//               <span>🚌</span>
//             </div>
//             <div>
//               <h1 className="header-title">Roam - GST Compliance Hub</h1>
//               <p className="header-subtitle">Manage bus transport GSTR-1 & GSTR-3B returns</p>
//             </div>
//           </div>
//           <div className="header-actions">
//             <div className="period-selector">
//               <span className="calendar-icon">📅</span>
//               <select 
//                 className="period-dropdown"
//                 value={selectedPeriod}
//                 onChange={(e) => setSelectedPeriod(e.target.value)}
//               >
//                 <option>Mar 2026</option>
//                 <option>Feb 2026</option>
//                 <option>Jan 2026</option>
//               </select>
//             </div>
//             <button className="btn-primary">
//               + New Filing
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="main-content">
//         {/* Summary Cards - Updated for bus business */}
//         <div className="summary-grid">
//           {summaryCards.map((card, idx) => (
//             <div key={idx} className={`summary-card summary-card-${card.color}`}>
//               <div className="card-header">
//                 <div>
//                   <p className="card-title">{card.title}</p>
//                   <h3 className="card-value">{card.value}</h3>
//                   <p className={`card-change ${card.change.startsWith('+') ? 'change-positive' : 'change-negative'}`}>
//                     {card.change} from last month
//                   </p>
//                 </div>
//                 <div className={`card-icon card-icon-${card.color}`}>
//                   <span>{card.icon}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Tabs Section */}
//         <div className="tabs-container">
//           <div className="tabs-header">
//             <button
//               onClick={() => setActiveTab('gstr1')}
//               className={`tab-button ${activeTab === 'gstr1' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">🎫</span>
//               <span>GSTR-1 (Ticket Sales Details)</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('gstr3b')}
//               className={`tab-button ${activeTab === 'gstr3b' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">📊</span>
//               <span>GSTR-3B (Tax Summary)</span>
//             </button>
//           </div>

//           <div className="tab-content">
//             {/* GSTR-1 Content - Updated for bus tickets */}
//             {activeTab === 'gstr1' && (
//               <div className="gstr1-content">
//                 {/* Action Bar */}
//                 <div className="action-bar">
//                   <div className="action-buttons">
//                     <button className="btn-secondary">
//                       <span>➕</span>
//                       <span>Add Ticket</span>
//                     </button>
//                     <button className="btn-outline">
//                       <span>📤</span>
//                       <span>Bulk Upload Tickets</span>
//                     </button>
//                     <button className="btn-outline">
//                       <span>📥</span>
//                       <span>Download Ticket Template</span>
//                     </button>
//                   </div>
//                   <div className="search-section">
//                     <div className="search-box">
//                       <span className="search-icon">🔍</span>
//                       <input
//                         type="text"
//                         placeholder="Search by ticket no., route, or operator..."
//                         className="search-input"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                       />
//                     </div>
//                     <button className="filter-btn">
//                       <span>⚙️</span>
//                     </button>
//                   </div>
//                 </div>

//                 {/* Ticket Table - Updated columns for bus transport */}
//                 <div className="table-container">
//                   <table className="data-table">
//                     <thead>
//                       <tr>
//                         <th>Ticket No.</th>
//                         <th>Operator GSTIN</th>
//                         <th>Date</th>
//                         <th>Route</th>
//                         <th>Service Type</th>
//                         <th>Trip Type</th>
//                         <th className="text-right">Ticket Value</th>
//                         <th className="text-right">GST</th>
//                         <th className="text-center">Status</th>
//                         <th className="text-center">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filteredTickets.map((ticket) => (
//                         <tr key={ticket.id}>
//                           <td>{ticket.ticketNo}</td>
//                           <td>{ticket.operatorGSTIN}</td>
//                           <td>{ticket.date}</td>
//                           <td>{ticket.route}</td>
//                           <td>
//                             <span className={`type-badge ${ticket.serviceType === 'Non-AC Bus' ? 'type-exempt' : 'type-b2b'}`}>
//                               {ticket.serviceType}
//                             </span>
//                           </td>
//                           <td>
//                             <span className={`trip-badge ${ticket.tripType === 'Inter-state' ? 'trip-inter' : 'trip-intra'}`}>
//                               {ticket.tripType}
//                             </span>
//                           </td>
//                           <td className="text-right">₹{ticket.taxableValue.toLocaleString()}</td>
//                           <td className="text-right">
//                             {ticket.isExempt ? (
//                               <span className="exempt-text">Exempt (0%)</span>
//                             ) : (
//                               `₹{(ticket.igst || (ticket.cgst + ticket.sgst) || 0).toLocaleString()}`
//                             )}
//                           </td>
//                           <td className="text-center">
//                             <div className="status-indicator">
//                               <span className="status-dot status-dot-green"></span>
//                               <span className="status-text">Validated</span>
//                             </div>
//                            </td>
//                           <td className="text-center">
//                             <button className="action-menu">⋮</button>
//                            </td>
//                          </tr>
//                       ))}
//                       {filteredTickets.length === 0 && (
//                         <tr>
//                           <td colSpan="10" className="no-data">
//                             No tickets found matching your search.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* Summary Footer - Updated */}
//                 <div className="summary-footer">
//                   <div className="summary-stats">
//                     <div>
//                       <p className="stat-label">Total Ticket Sales (Excluding GST)</p>
//                       <p className="stat-value">₹{totalTaxableValue.toLocaleString()}</p>
//                     </div>
//                     <div>
//                       <p className="stat-label">Total GST Collected</p>
//                       <p className="stat-value">₹{totalTaxAmount.toLocaleString()}</p>
//                     </div>
//                     <div>
//                       <p className="stat-label">Exempt Sales (Non-AC Buses)</p>
//                       <p className="stat-value">₹500</p>
//                     </div>
//                   </div>
//                   <button className="btn-generate">
//                     <span>Generate GSTR-1 Summary</span>
//                     <span>→</span>
//                   </button>
//                 </div>

//                 {/* GST Rate Info Box */}
//                 <div className="gst-info-box">
//                   <span className="info-icon">ℹ️</span>
//                   <div className="info-content">
//                     <strong>GST Rates Applied:</strong> AC Buses @ 5% IGST/CGST+SGST | Non-AC Buses @ 0% (Exempt) | Luxury Coaches @ 5% or 12% (Option)
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* GSTR-3B Content - Updated for bus operations */}
//             {activeTab === 'gstr3b' && (
//               <div className="gstr3b-content">
//                 {/* Ledger Cards - Updated */}
//                 <div className="ledger-grid">
//                   <div className="ledger-card ledger-card-green">
//                     <div className="ledger-header">
//                       <div className="ledger-icon">
//                         <span>💰</span>
//                       </div>
//                       <div className="ledger-info">
//                         <p className="ledger-label">Electronic Cash Ledger</p>
//                         <p className="ledger-amount">₹{ledgers.cash.toLocaleString()}</p>
//                       </div>
//                       <span className="ledger-trend">↗</span>
//                     </div>
//                     <div className="ledger-footer">Available for tax payment from ticket collections</div>
//                   </div>
                  
//                   <div className="ledger-card ledger-card-purple">
//                     <div className="ledger-header">
//                       <div className="ledger-icon">
//                         <span>⛽</span>
//                       </div>
//                       <div className="ledger-info">
//                         <p className="ledger-label">Electronic Credit Ledger (ITC)</p>
//                         <p className="ledger-amount">₹{ledgers.credit.toLocaleString()}</p>
//                       </div>
//                       <span className="ledger-trend">↗</span>
//                     </div>
//                     <div className="ledger-footer">ITC from fuel, maintenance, vehicle purchases (eligible buses)</div>
//                   </div>
//                 </div>

//                 {/* Liability Table - Updated for bus transport */}
//                 <div className="liability-table-container">
//                   <div className="table-header">
//                     <h3 className="section-title">Tax Liability & ITC Utilization (Bus Operations)</h3>
//                     <p className="table-subtitle">Based on ticket sales for {selectedPeriod}</p>
//                   </div>
//                   <div className="table-responsive">
//                     <table className="liability-table">
//                       <thead>
//                         <tr>
//                           <th>Tax Head</th>
//                           <th className="text-right">Total Liability (from tickets)</th>
//                           <th className="text-right">ITC Used (fuel/maintenance)</th>
//                           <th className="text-right">Cash to Pay</th>
//                           <th className="text-center">Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td className="font-medium uppercase">IGST</td>
//                           <td className="text-right font-semibold">₹{liabilitySummary.igst.liability.toLocaleString()}</td>
//                           <td className="text-right text-green">- ₹{liabilitySummary.igst.itcUsed.toLocaleString()}</td>
//                           <td className="text-right font-bold">₹{liabilitySummary.igst.cashPaid.toLocaleString()}</td>
//                           <td className="text-center">
//                             <span className="status-badge status-badge-success">✓ Settled</span>
//                           </td>
//                          </tr>
//                         <tr>
//                           <td className="font-medium uppercase">CGST</td>
//                           <td className="text-right font-semibold">₹{liabilitySummary.cgst.liability.toLocaleString()}</td>
//                           <td className="text-right text-green">- ₹{liabilitySummary.cgst.itcUsed.toLocaleString()}</td>
//                           <td className="text-right font-bold">₹{liabilitySummary.cgst.cashPaid.toLocaleString()}</td>
//                           <td className="text-center">
//                             <span className="status-badge status-badge-success">✓ Settled</span>
//                           </td>
//                          </tr>
//                         <tr>
//                           <td className="font-medium uppercase">SGST</td>
//                           <td className="text-right font-semibold">₹{liabilitySummary.sgst.liability.toLocaleString()}</td>
//                           <td className="text-right text-green">- ₹{liabilitySummary.sgst.itcUsed.toLocaleString()}</td>
//                           <td className="text-right font-bold">₹{liabilitySummary.sgst.cashPaid.toLocaleString()}</td>
//                           <td className="text-center">
//                             <span className="status-badge status-badge-success">✓ Settled</span>
//                           </td>
//                          </tr>
//                       </tbody>
//                       <tfoot>
//                         <tr>
//                           <td className="font-bold">Total</td>
//                           <td className="text-right font-bold">₹{Object.values(liabilitySummary).reduce((sum, h) => sum + h.liability, 0).toLocaleString()}</td>
//                           <td className="text-right font-bold text-green">- ₹{Object.values(liabilitySummary).reduce((sum, h) => sum + h.itcUsed, 0).toLocaleString()}</td>
//                           <td className="text-right font-bold text-blue">₹{Object.values(liabilitySummary).reduce((sum, h) => sum + h.cashPaid, 0).toLocaleString()}</td>
//                           <td></td>
//                          </tr>
//                       </tfoot>
//                     </table>
//                   </div>
//                 </div>

//                 {/* ITC Eligibility Note */}
//                 <div className="itc-note">
//                   <span className="note-icon">ⓘ</span>
//                   <div className="note-content">
//                     <strong>ITC Eligibility Note:</strong> You can claim ITC on fuel, repairs, and vehicle purchases for buses with seating capacity &gt; 13 persons (including driver). ITC not available for minibuses/vehicles with ≤13 seats.
//                   </div>
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="action-buttons-footer">
//                   <button className="btn-outline-secondary">
//                     Save as Draft
//                   </button>
//                   <button className="btn-primary-gradient">
//                     Preview & File GSTR-3B
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Recent Activity - Updated */}
//         <div className="recent-activity">
//           <div className="activity-header">
//             <h3 className="section-title">Recent GST Filing Activity</h3>
//             <button className="view-all-btn">View all →</button>
//           </div>
//           <div className="activity-list">
//             {[
//               { type: 'GSTR-3B', period: 'Feb 2026', date: '20 Mar 2026', status: 'filed', arn: 'ARN123456789', taxPaid: '₹39,500' },
//               { type: 'GSTR-1', period: 'Feb 2026', date: '18 Mar 2026', status: 'filed', arn: 'ARN987654321', tickets: '1,128' },
//               { type: 'GSTR-3B', period: 'Jan 2026', date: '19 Feb 2026', status: 'filed', arn: 'ARN456789123', taxPaid: '₹42,000' },
//             ].map((activity, idx) => (
//               <div key={idx} className="activity-item">
//                 <div className="activity-left">
//                   <div className={`activity-icon ${activity.type === 'GSTR-1' ? 'icon-blue' : 'icon-green'}`}>
//                     {activity.type === 'GSTR-1' ? '🎫' : '📊'}
//                   </div>
//                   <div>
//                     <p className="activity-title">{activity.type}</p>
//                     <p className="activity-subtitle">{activity.period} • ARN: {activity.arn}</p>
//                     {activity.taxPaid && <p className="activity-subtitle">Tax Paid: {activity.taxPaid}</p>}
//                     {activity.tickets && <p className="activity-subtitle">Tickets: {activity.tickets}</p>}
//                   </div>
//                 </div>
//                 <div className="activity-right">
//                   <span className={`status-badge ${getStatusBadgeClass(activity.status)}`}>
//                     {activity.status.charAt(0).toUpperCase() + activity.status.slice(1)}
//                   </span>
//                   <span className="activity-date">{activity.date}</span>
//                   <button className="download-btn">📥</button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GSTAdminPanel;

import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  getGSTR1,
  getGSTR3B,
  downloadGSTR1CSV,
  downloadGSTR1PDF,
  downloadGSTR3BCSV,
  downloadGSTR3BPDF,
  getGSTDashboard,
  getGSTInvoices,
  getGSTInvoiceById,
  generateGSTInvoices,
  cancelGSTInvoice,
  getGSTRates,
} from '../../Services/Operations/ProductAPI';
import '../../Styles/GSTAdmin.css';

// Skeleton Components
const SkeletonSummaryCard = () => (
  <div className="summary-card skeleton">
    <div className="card-header">
      <div>
        <div className="skeleton-title"></div>
        <div className="skeleton-value"></div>
        <div className="skeleton-change"></div>
      </div>
      <div className="skeleton-icon"></div>
    </div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-status"></div></td>
    <td><div className="skeleton-action"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>Invoice No.</th>
          <th>PNR</th>
          <th>Date</th>
          <th>Route</th>
          <th>Taxable Value</th>
          <th>GST Rate</th>
          <th>CGST</th>
          <th>SGST</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const GSTAdminPanel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  
  // State for API data
  const [dashboardData, setDashboardData] = useState(null);
  const [gstr1Data, setGstr1Data] = useState(null);
  const [gstr3bData, setGstr3bData] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [gstRates, setGstRates] = useState([]);
  const [generatingInvoices, setGeneratingInvoices] = useState(false);
  const [cancellingInvoice, setCancellingInvoice] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, pages: 1 });
  const [error, setError] = useState(null);
  
  // State for filters
  const [filters, setFilters] = useState({
    status: '',
    month: '',
    year: '',
    busOwner: ''
  });

  // Get token from Redux (same as ProfitReport)
  const { token } = useSelector(state => state.user);

  // Show notification
  const showNotification = (message, type = 'success') => {
    setNotification({ show: true, message, type });
    setTimeout(() => setNotification({ show: false, message: '', type: '' }), 5000);
  };

  // Fetch Dashboard Data
  const fetchDashboardData = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true);
      const response = await getGSTDashboard(selectedYear, token);
      if (response.success) {
        setDashboardData(response.data);
        setError(null);
      } else {
        setError('Failed to load dashboard data');
      }
    } catch (error) {
      console.error('Error fetching dashboard:', error);
      setError(error.response?.data?.message || 'Failed to load dashboard data');
      showNotification('Failed to load dashboard data', 'error');
    } finally {
      setLoading(false);
    }
  }, [selectedYear, token]);

  // Fetch GSTR-1 Data
  const fetchGSTR1Data = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true);
      const response = await getGSTR1(selectedMonth, selectedYear, null, token);
      if (response.success) {
        setGstr1Data(response.data);
        setError(null);
      } else {
        setError('Failed to load GSTR-1 data');
      }
    } catch (error) {
      console.error('Error fetching GSTR-1:', error);
      setError(error.response?.data?.message || 'Failed to load GSTR-1 data');
      showNotification('Failed to load GSTR-1 data', 'error');
    } finally {
      setLoading(false);
    }
  }, [selectedMonth, selectedYear, token]);

  // Fetch GSTR-3B Data
  const fetchGSTR3BData = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true);
      const response = await getGSTR3B(selectedMonth, selectedYear, null, token);
      if (response.success) {
        setGstr3bData(response.data);
        setError(null);
      } else {
        setError('Failed to load GSTR-3B data');
      }
    } catch (error) {
      console.error('Error fetching GSTR-3B:', error);
      setError(error.response?.data?.message || 'Failed to load GSTR-3B data');
      showNotification('Failed to load GSTR-3B data', 'error');
    } finally {
      setLoading(false);
    }
  }, [selectedMonth, selectedYear, token]);

  // Fetch Invoices
  const fetchInvoices = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true);
      const response = await getGSTInvoices(currentPage, itemsPerPage, filters, token);
      if (response.success) {
        setInvoices(response.data.invoices);
        setPagination(response.data.pagination);
        setError(null);
      } else {
        setError('Failed to load invoices');
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      setError(error.response?.data?.message || 'Failed to load invoices');
      showNotification('Failed to load invoices', 'error');
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, filters, token]);

  // Fetch GST Rates
  const fetchGSTRates = useCallback(async () => {
    if (!token) return;
    try {
      const response = await getGSTRates({}, token);
      if (response.success) {
        setGstRates(response.data);
      }
    } catch (error) {
      console.error('Error fetching GST rates:', error);
    }
  }, [token]);

  // Handle invoice generation
  const handleGenerateInvoices = async () => {
    if (!token) {
      showNotification('Please login first', 'error');
      return;
    }
    setGeneratingInvoices(true);
    try {
      const response = await generateGSTInvoices(selectedMonth, selectedYear, token);
      if (response.success) {
        showNotification(response.message, 'success');
        fetchInvoices();
        fetchDashboardData();
      } else {
        showNotification(response.message || 'Failed to generate invoices', 'error');
      }
    } catch (error) {
      console.error('Error generating invoices:', error);
      showNotification(error.response?.data?.message || 'Failed to generate invoices', 'error');
    } finally {
      setGeneratingInvoices(false);
    }
  };

  // Handle invoice cancellation
  const handleCancelInvoice = async (invoiceId, reason) => {
    if (!token) {
      showNotification('Please login first', 'error');
      return;
    }
    setCancellingInvoice(true);
    try {
      const response = await cancelGSTInvoice(invoiceId, reason, token);
      if (response.success) {
        showNotification('Invoice cancelled and credit note created', 'success');
        fetchInvoices();
        fetchDashboardData();
        setShowInvoiceModal(false);
      } else {
        showNotification(response.message || 'Failed to cancel invoice', 'error');
      }
    } catch (error) {
      console.error('Error cancelling invoice:', error);
      showNotification(error.response?.data?.message || 'Failed to cancel invoice', 'error');
    } finally {
      setCancellingInvoice(false);
    }
  };

  // Handle view invoice details
  const handleViewInvoice = async (invoiceId) => {
    if (!token) {
      showNotification('Please login first', 'error');
      return;
    }
    try {
      setLoading(true);
      const response = await getGSTInvoiceById(invoiceId, token);
      if (response.success) {
        setSelectedInvoice(response.data);
        setShowInvoiceModal(true);
      } else {
        showNotification('Failed to load invoice details', 'error');
      }
    } catch (error) {
      console.error('Error fetching invoice details:', error);
      showNotification('Failed to load invoice details', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Handle download functions
  const handleDownloadGSTR1CSV = async () => {
    if (!token) {
      showNotification('Please login first', 'error');
      return;
    }
    try {
      const blob = await downloadGSTR1CSV(selectedMonth, selectedYear, null, token);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `GSTR1_${selectedMonth}_${selectedYear}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      showNotification('GSTR-1 CSV downloaded successfully', 'success');
    } catch (error) {
      console.error('Error downloading GSTR-1 CSV:', error);
      showNotification('Failed to download GSTR-1 CSV', 'error');
    }
  };

  const handleDownloadGSTR1PDF = async () => {
    if (!token) {
      showNotification('Please login first', 'error');
      return;
    }
    try {
      const blob = await downloadGSTR1PDF(selectedMonth, selectedYear, null, token);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `GSTR1_${selectedMonth}_${selectedYear}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      showNotification('GSTR-1 PDF downloaded successfully', 'success');
    } catch (error) {
      console.error('Error downloading GSTR-1 PDF:', error);
      showNotification('Failed to download GSTR-1 PDF', 'error');
    }
  };

  const handleDownloadGSTR3BCSV = async () => {
    if (!token) {
      showNotification('Please login first', 'error');
      return;
    }
    try {
      const blob = await downloadGSTR3BCSV(selectedMonth, selectedYear, null, token);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `GSTR3B_${selectedMonth}_${selectedYear}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      showNotification('GSTR-3B CSV downloaded successfully', 'success');
    } catch (error) {
      console.error('Error downloading GSTR-3B CSV:', error);
      showNotification('Failed to download GSTR-3B CSV', 'error');
    }
  };

  const handleDownloadGSTR3BPDF = async () => {
    if (!token) {
      showNotification('Please login first', 'error');
      return;
    }
    try {
      const blob = await downloadGSTR3BPDF(selectedMonth, selectedYear, null, token);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `GSTR3B_${selectedMonth}_${selectedYear}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      showNotification('GSTR-3B PDF downloaded successfully', 'success');
    } catch (error) {
      console.error('Error downloading GSTR-3B PDF:', error);
      showNotification('Failed to download GSTR-3B PDF', 'error');
    }
  };

  // Handle refresh
  const handleRefresh = () => {
    if (activeTab === 'dashboard') {
      fetchDashboardData();
    } else if (activeTab === 'gstr1') {
      fetchGSTR1Data();
    } else if (activeTab === 'gstr3b') {
      fetchGSTR3BData();
    } else if (activeTab === 'invoices') {
      setCurrentPage(1);
      fetchInvoices();
    }
  };

  // Initial load
  useEffect(() => {
    if (token) {
      fetchDashboardData();
      fetchGSTRates();
    }
  }, [fetchDashboardData, fetchGSTRates, token]);

  useEffect(() => {
    if (token) {
      if (activeTab === 'gstr1') {
        fetchGSTR1Data();
      } else if (activeTab === 'gstr3b') {
        fetchGSTR3BData();
      } else if (activeTab === 'invoices') {
        fetchInvoices();
      }
    }
  }, [activeTab, fetchGSTR1Data, fetchGSTR3BData, fetchInvoices, token]);

  // Format currency
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '₹0';
    return `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  // Get month name
  const getMonthName = (month) => {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[month - 1];
  };

  // Dashboard Summary Cards
  const getSummaryCards = () => {
    if (!dashboardData) return [];
    return [
      { title: 'Total Invoices', value: dashboardData.currentMonth?.count || 0, change: '+0%', icon: '📄', color: 'blue' },
      { title: 'Total Taxable Value', value: formatCurrency(dashboardData.currentMonth?.totalTaxable || 0), change: '+0%', icon: '💰', color: 'green' },
      { title: 'Total GST Collected', value: formatCurrency(dashboardData.currentMonth?.totalGST || 0), change: '+0%', icon: '🏷️', color: 'purple' },
      { title: 'Pending Invoices', value: dashboardData.pendingInvoiceGeneration || 0, change: '⚠️', icon: '⏳', color: 'orange' },
    ];
  };

  // Loading skeleton for initial load
  if (loading && !dashboardData && activeTab === 'dashboard') {
    return (
      <div className="gst-admin-container">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>
        <div className="summary-grid">
          {[1, 2, 3, 4].map((i) => <SkeletonSummaryCard key={i} />)}
        </div>
        <div className="skeleton-table"></div>
      </div>
    );
  }

  return (
    <div className="gst-admin-container">
      {/* Notification */}
      {notification.show && (
        <div className={`notification notification-${notification.type}`}>
          <span>{notification.message}</span>
          <button onClick={() => setNotification({ show: false, message: '', type: '' })}>×</button>
        </div>
      )}

      {/* Error Message */}
      {error && (
        <div className="error-message">
          {error}
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}

      {/* Header */}
      <header className="gst-header">
        <div className="header-content">
          <div className="logo-section">
            <div className="logo-icon">
              <span>🚌</span>
            </div>
            <div>
              <h1 className="header-title">Roam - GST Compliance Hub</h1>
              <p className="header-subtitle">Manage bus transport GSTR-1 & GSTR-3B returns</p>
            </div>
          </div>
          <div className="header-actions">
            <div className="period-selector">
              <span className="calendar-icon">📅</span>
              <select 
                className="period-dropdown"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => (
                  <option key={m} value={m}>{getMonthName(m)}</option>
                ))}
              </select>
              <select 
                className="period-dropdown"
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              >
                {[2024, 2025, 2026, 2027].map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
            <button className="btn-primary" onClick={handleGenerateInvoices} disabled={generatingInvoices}>
              {generatingInvoices ? 'Generating...' : '+ Generate Invoices'}
            </button>
            <button className="refresh-btn" onClick={handleRefresh} disabled={loading}>
              🔄 Refresh
            </button>
          </div>
        </div>
      </header>

      <div className="main-content">
        {/* Summary Cards */}
        <div className="summary-grid">
          {getSummaryCards().map((card, idx) => (
            <div key={idx} className={`summary-card summary-card-${card.color}`}>
              <div className="card-header">
                <div>
                  <p className="card-title">{card.title}</p>
                  <h3 className="card-value">{card.value}</h3>
                  <p className={`card-change ${card.change.startsWith('+') ? 'change-positive' : 'change-negative'}`}>
                    {card.change} from last month
                  </p>
                </div>
                <div className={`card-icon card-icon-${card.color}`}>
                  <span>{card.icon}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tabs Section */}
        <div className="tabs-container">
          <div className="tabs-header">
            <button
              onClick={() => setActiveTab('dashboard')}
              className={`tab-button ${activeTab === 'dashboard' ? 'tab-active' : ''}`}
            >
              <span className="tab-icon">📊</span>
              <span>Dashboard</span>
            </button>
            <button
              onClick={() => setActiveTab('gstr1')}
              className={`tab-button ${activeTab === 'gstr1' ? 'tab-active' : ''}`}
            >
              <span className="tab-icon">📋</span>
              <span>GSTR-1</span>
            </button>
            <button
              onClick={() => setActiveTab('gstr3b')}
              className={`tab-button ${activeTab === 'gstr3b' ? 'tab-active' : ''}`}
            >
              <span className="tab-icon">📊</span>
              <span>GSTR-3B</span>
            </button>
            <button
              onClick={() => setActiveTab('invoices')}
              className={`tab-button ${activeTab === 'invoices' ? 'tab-active' : ''}`}
            >
              <span className="tab-icon">📄</span>
              <span>Invoices</span>
            </button>
            <button
              onClick={() => setActiveTab('rates')}
              className={`tab-button ${activeTab === 'rates' ? 'tab-active' : ''}`}
            >
              <span className="tab-icon">⚙️</span>
              <span>GST Rates</span>
            </button>
          </div>

          <div className="tab-content">
            {/* Dashboard Tab Content - Same as before but with loading indicator */}
            {activeTab === 'dashboard' && dashboardData && (
              <div className="dashboard-content">
                {loading && <div className="loading-overlay"><div className="loading-spinner"></div></div>}
                {/* Dashboard content remains the same */}
                <div className="trend-chart">
                  <h3>Monthly GST Collection Trend</h3>
                  <div className="chart-bars">
                    {dashboardData.financialYearMonthly?.map((item, idx) => (
                      <div key={idx} className="chart-bar-container">
                        <div 
                          className="chart-bar" 
                          style={{ 
                            height: `${Math.min((item.totalGST / 10000) * 100, 100)}%`,
                            backgroundColor: '#4F46E5'
                          }}
                        ></div>
                        <span className="chart-label">{getMonthName(item._id.month).slice(0, 3)}</span>
                        <span className="chart-value">{formatCurrency(item.totalGST)}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="financial-summary">
                  <h3>Financial Year {dashboardData.financialYear} Summary</h3>
                  <div className="summary-stats-grid">
                    <div className="stat-item">
                      <span className="stat-label">Total Invoices</span>
                      <span className="stat-value">{dashboardData.financialYearMonthly?.reduce((sum, i) => sum + i.count, 0) || 0}</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-label">Total GST Collected</span>
                      <span className="stat-value">{formatCurrency(dashboardData.financialYearMonthly?.reduce((sum, i) => sum + i.totalGST, 0) || 0)}</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-label">Total Invoice Value</span>
                      <span className="stat-value">{formatCurrency(dashboardData.financialYearMonthly?.reduce((sum, i) => sum + i.totalValue, 0) || 0)}</span>
                    </div>
                  </div>
                </div>

                {dashboardData.pendingInvoiceGeneration > 0 && (
                  <div className="pending-alert">
                    <div className="alert-icon">⚠️</div>
                    <div className="alert-content">
                      <h4>{dashboardData.pendingInvoiceGeneration} bookings pending invoice generation</h4>
                      <p>Click "Generate Invoices" to create GST invoices for these bookings</p>
                    </div>
                    <button className="alert-action" onClick={handleGenerateInvoices}>
                      Generate Now
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* GSTR-1 Tab Content */}
            {activeTab === 'gstr1' && gstr1Data && (
              <div className="gstr1-content">
                {loading && <div className="loading-overlay"><div className="loading-spinner"></div></div>}
                <div className="action-bar">
                  <div className="action-buttons">
                    <button className="btn-secondary" onClick={handleDownloadGSTR1CSV}>
                      <span>📥</span>
                      <span>Download CSV</span>
                    </button>
                    <button className="btn-secondary" onClick={handleDownloadGSTR1PDF}>
                      <span>📄</span>
                      <span>Download PDF</span>
                    </button>
                  </div>
                </div>

                <div className="summary-section">
                  <h3>GSTR-1 Summary - {getMonthName(selectedMonth)} {selectedYear}</h3>
                  <div className="summary-grid-small">
                    <div className="summary-item">
                      <span className="summary-label">Total Invoices</span>
                      <span className="summary-value">{gstr1Data.summary?.totalInvoices || 0}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Total Taxable Value</span>
                      <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalTaxableValue || 0)}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Total CGST</span>
                      <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalCGST || 0)}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Total SGST</span>
                      <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalSGST || 0)}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Total IGST</span>
                      <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalIGST || 0)}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Total GST</span>
                      <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalGST || 0)}</span>
                    </div>
                  </div>
                </div>

                {/* Rest of GSTR-1 content remains the same */}
              </div>
            )}

            {/* GSTR-3B Tab Content */}
            {activeTab === 'gstr3b' && gstr3bData && (
              <div className="gstr3b-content">
                {loading && <div className="loading-overlay"><div className="loading-spinner"></div></div>}
                {/* GSTR-3B content remains the same */}
              </div>
            )}

            {/* Invoices Tab Content */}
            {activeTab === 'invoices' && (
              <div className="invoices-content">
                <div className="filters-bar">
                  <div className="search-box">
                    <span className="search-icon">🔍</span>
                    <input
                      type="text"
                      placeholder="Search by invoice number or PNR..."
                      className="search-input"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <select 
                    className="filter-select"
                    value={filters.status}
                    onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                  >
                    <option value="">All Status</option>
                    <option value="active">Active</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="credit_note">Credit Note</option>
                  </select>
                  <button className="btn-refresh" onClick={handleRefresh}>
                    🔄 Refresh
                  </button>
                </div>

                {/* Invoices Table */}
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Invoice No.</th>
                        <th>PNR</th>
                        <th>Date</th>
                        <th>Route</th>
                        <th className="text-right">Taxable Value</th>
                        <th className="text-right">CGST</th>
                        <th className="text-right">SGST</th>
                        <th className="text-right">Total</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading && invoices.length === 0 ? (
                        [...Array(5)].map((_, i) => <SkeletonTableRow key={i} />)
                      ) : invoices.length === 0 ? (
                        <tr>
                          <td colSpan="10" className="no-data">No invoices found</td>
                        </tr>
                      ) : (
                        invoices.map((invoice) => (
                          <tr key={invoice._id}>
                            <td>{invoice.invoiceNumber}</td>
                            <td>{invoice.pnr}</td>
                            <td>{formatDate(invoice.invoiceDate)}</td>
                            <td>
                              {invoice.booking?.route?.from} → {invoice.booking?.route?.to}
                            </td>
                            <td className="text-right">{formatCurrency(invoice.totalTaxableValue)}</td>
                            <td className="text-right">{formatCurrency(invoice.totalCGST)}</td>
                            <td className="text-right">{formatCurrency(invoice.totalSGST)}</td>
                            <td className="text-right">{formatCurrency(invoice.totalInvoiceValue)}</td>
                            <td className="text-center">
                              <span className={`status-badge status-${invoice.status}`}>
                                {invoice.status === 'active' ? 'Active' : invoice.status === 'cancelled' ? 'Cancelled' : 'Credit Note'}
                              </span>
                            </td>
                            <td className="text-center">
                              <button 
                                className="action-btn view" 
                                onClick={() => handleViewInvoice(invoice._id)}
                                title="View"
                              >
                                👁️
                              </button>
                              {invoice.status === 'active' && (
                                <button 
                                  className="action-btn cancel" 
                                  onClick={() => {
                                    const reason = prompt('Enter cancellation reason:');
                                    if (reason) handleCancelInvoice(invoice._id, reason);
                                  }}
                                  title="Cancel"
                                >
                                  ❌
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {pagination.pages > 1 && (
                  <div className="pagination-container">
                    <div className="pagination-info">
                      Showing {invoices.length} of {pagination.total} invoices
                      (Page {currentPage} of {pagination.pages})
                    </div>
                    <div className="pagination-controls">
                      <button 
                        className="pagination-btn"
                        disabled={currentPage === 1 || loading}
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        Previous
                      </button>
                      <span className="page-number active">{currentPage}</span>
                      <button 
                        className="pagination-btn"
                        disabled={currentPage === pagination.pages || loading}
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* GST Rates Tab Content */}
            {activeTab === 'rates' && (
              <div className="rates-content">
                <div className="table-section">
                  <h3>GST Rates Configuration</h3>
                  <div className="table-container">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>Service Type</th>
                          <th>Tax Type</th>
                          <th className="text-right">GST Rate (%)</th>
                          <th className="text-right">CGST (%)</th>
                          <th className="text-right">SGST (%)</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>AC Bus</td>
                          <td>Intra-State</td>
                          <td className="text-right">5%</td>
                          <td className="text-right">2.5%</td>
                          <td className="text-right">2.5%</td>
                          <td><span className="status-badge status-active">Active</span></td>
                        </tr>
                        <tr>
                          <td>AC Bus</td>
                          <td>Inter-State</td>
                          <td className="text-right">5%</td>
                          <td className="text-right">-</td>
                          <td className="text-right">-</td>
                          <td><span className="status-badge status-active">Active</span></td>
                        </tr>
                        <tr>
                          <td>Non-AC Bus</td>
                          <td>All</td>
                          <td className="text-right">0%</td>
                          <td className="text-right">0%</td>
                          <td className="text-right">0%</td>
                          <td><span className="status-badge status-exempt">Exempt</span></td>
                        </tr>
                        <tr>
                          <td>Luxury Coach</td>
                          <td>Intra-State</td>
                          <td className="text-right">12%</td>
                          <td className="text-right">6%</td>
                          <td className="text-right">6%</td>
                          <td><span className="status-badge status-active">Active</span></td>
                        </tr>
                        <tr>
                          <td>Luxury Coach</td>
                          <td>Inter-State</td>
                          <td className="text-right">12%</td>
                          <td className="text-right">-</td>
                          <td className="text-right">-</td>
                          <td><span className="status-badge status-active">Active</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="gst-info-box">
                  <span className="info-icon">ℹ️</span>
                  <div className="info-content">
                    <strong>GST Rates Applied:</strong> AC Buses @ 5% IGST/CGST+SGST | Non-AC Buses @ 0% (Exempt) | Luxury Coaches @ 12%
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Invoice Modal */}
      {showInvoiceModal && selectedInvoice && (
        <div className="modal-overlay" onClick={() => setShowInvoiceModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Invoice Details</h2>
              <button className="modal-close" onClick={() => setShowInvoiceModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="invoice-details">
                <div className="detail-row">
                  <span className="detail-label">Invoice Number:</span>
                  <span className="detail-value">{selectedInvoice.invoiceNumber}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">PNR:</span>
                  <span className="detail-value">{selectedInvoice.pnr}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Invoice Date:</span>
                  <span className="detail-value">{formatDate(selectedInvoice.invoiceDate)}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Financial Year:</span>
                  <span className="detail-value">{selectedInvoice.financialYear}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Recipient:</span>
                  <span className="detail-value">{selectedInvoice.recipient?.name}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Place of Supply:</span>
                  <span className="detail-value">{selectedInvoice.placeOfSupply?.stateName}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Inter-State:</span>
                  <span className="detail-value">{selectedInvoice.isInterState ? 'Yes' : 'No'}</span>
                </div>
                <hr />
                <div className="detail-row">
                  <span className="detail-label">Taxable Value:</span>
                  <span className="detail-value">{formatCurrency(selectedInvoice.totalTaxableValue)}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">CGST:</span>
                  <span className="detail-value">{formatCurrency(selectedInvoice.totalCGST)}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">SGST:</span>
                  <span className="detail-value">{formatCurrency(selectedInvoice.totalSGST)}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Total Invoice Value:</span>
                  <span className="detail-value">{formatCurrency(selectedInvoice.totalInvoiceValue)}</span>
                </div>
                <hr />
                <div className="detail-row">
                  <span className="detail-label">Status:</span>
                  <span className={`detail-value status-${selectedInvoice.status}`}>
                    {selectedInvoice.status === 'active' ? 'Active' : selectedInvoice.status === 'cancelled' ? 'Cancelled' : 'Credit Note'}
                  </span>
                </div>
                {selectedInvoice.notes && (
                  <div className="detail-row">
                    <span className="detail-label">Notes:</span>
                    <span className="detail-value">{selectedInvoice.notes}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              {selectedInvoice.status === 'active' && (
                <button 
                  className="btn-danger"
                  onClick={() => {
                    const reason = prompt('Enter cancellation reason:');
                    if (reason) {
                      handleCancelInvoice(selectedInvoice._id, reason);
                    }
                  }}
                  disabled={cancellingInvoice}
                >
                  {cancellingInvoice ? 'Cancelling...' : 'Cancel Invoice'}
                </button>
              )}
              <button className="btn-secondary" onClick={() => setShowInvoiceModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GSTAdminPanel;